import { FC } from "react"
import CampaignChartTable from "../CampaignChartTable"
import CampaignsChart from "../CampaignsChart"
import type {
  DashboardReporting,
  ReportingData,
} from "@/types/entities/organization"
import type { DashboardGrouping } from "@/pages/Dashboard/hooks/utils"

type Props = {
  className?: string
  label: string
  indicators: string[]
  reporting: DashboardReporting
  selectedIndicators: Record<string, boolean>
  selectedClassifications: Partial<Record<string, boolean>>
  from: Date
  to: Date
  grouping: DashboardGrouping
}

const mergeByDate = (items: Array<Pick<ReportingData, "_id">>) =>
  items.filter(
    (item, i, arr) =>
      i ===
      arr.findIndex((t) => JSON.stringify(item._id) === JSON.stringify(t._id)),
  )

const SingleGraphView: FC<Props> = ({
  label,
  indicators,
  reporting,
  selectedIndicators,
  selectedClassifications,
  from,
  to,
  grouping,
}: Props) => {
  const bounces = reporting.bounces ?? { data: [], totals: [{ total: 0 }] }
  const resultEmails = mergeByDate(
    reporting.emails.data
      .concat(reporting.replies.data.map(({ _id }) => ({ _id })) as any)
      .concat(bounces.data.map(({ _id }) => ({ _id })) as any),
  ).map((email) => {
    let resultData: ReportingData = {
      new: 0,
      followup: 0,
      total: 0,
      ...email,
      _id: email._id,
    }
    const correspondingReply = reporting.replies.data.find(
      (reply) => JSON.stringify(reply._id) === JSON.stringify(email._id),
    )
    if (correspondingReply) {
      resultData = Object.assign(resultData, {
        ...correspondingReply,
      })
    }
    const correspondingBounces = bounces.data.find(
      (bounce) => JSON.stringify(bounce._id) === JSON.stringify(email._id),
    )
    if (correspondingBounces) {
      resultData = Object.assign(resultData, {
        bounces: correspondingBounces.total,
      })
    }
    return resultData
  })
  return (
    <div className="space-y-4">
      <h2 className="text-base font-semibold">{label}</h2>
      <CampaignsChart
        emails={resultEmails}
        totalData={
          reporting.emails.totals[0] || { new: 0, followup: 0, total: 0 }
        }
        totalReplyData={reporting.replies.totals[0] || { reply: 0, lead: 0 }}
        totalBounceData={bounces.totals[0] || { total: 0 }}
        selectedIndicators={selectedIndicators}
        selectedClassifications={selectedClassifications}
        from={from}
        to={to}
        grouping={grouping}
        indicators={indicators}
      />
      <CampaignChartTable emails={resultEmails} />
    </div>
  )
}

export default SingleGraphView
